import React from "react";
import { Skeleton } from "antd";
import styles from "./kanbanSkeleton.module.css";

interface KanbanSkeletonProps {
  columns?: number;
  cardsPerColumn?: number;
}

const KanbanSkeleton: React.FC<KanbanSkeletonProps> = ({
  columns = 4,
  cardsPerColumn = 3,
}) => {
  return (
    <div className={styles.skeletonContainer}>
      {Array.from({ length: columns }).map((_, columnIndex) => (
        <div
          key={columnIndex}
          className={styles.skeletonColumn}
        >
          {/* Column Header Skeleton */}
          <div className={styles.columnHeader}>
            <Skeleton.Input
              active
              size='small'
              style={{ width: 120, height: 24 }}
            />
            <Skeleton.Avatar
              active
              size='small'
              shape='circle'
            />
          </div>

          {/* Card Skeletons */}
          <div className={styles.columnBody}>
            {Array.from({ length: cardsPerColumn }).map((_, cardIndex) => (
              <div
                key={cardIndex}
                className={styles.cardSkeleton}
              >
                <div className={styles.cardHeader}>
                  <Skeleton.Input
                    active
                    size='small'
                    style={{ width: "60%", height: 16 }}
                  />
                  <Skeleton.Avatar
                    active
                    size='small'
                    shape='circle'
                  />
                </div>

                <Skeleton
                  active
                  paragraph={{ rows: 2, width: ["100%", "80%"] }}
                  title={false}
                />

                <div className={styles.cardFooter}>
                  <div className={styles.cardFooterLeft}>
                    <Skeleton.Avatar
                      active
                      size='small'
                      shape='circle'
                    />
                    <Skeleton.Input
                      active
                      size='small'
                      style={{ width: 60, height: 16 }}
                    />
                  </div>
                  <Skeleton.Input
                    active
                    size='small'
                    style={{ width: 40, height: 16 }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default KanbanSkeleton;
